// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"EditorContent_wrapper__2t0Ik","left":"EditorContent_left__UpFQO","right":"EditorContent_right___9UUv","center":"EditorContent_center__qGYHv"};